package com.essntl.features.request.domain.model

import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class RequestModel(
    val id: String,
    val title: String?,
    val htmlEmail: String?,
    val createdAt: String,
    val startDate: String,
    val endDate: String,
    val guestCount: Int,
    val areas: List<String>?,
    val proposalId: String?,
    val travelAgent: TravelAgentModel?,
    val extras: String?,
    val ownerId: String?,
    val status: Status?,
    val clients: List<String>?,
    val guestDetails: String?,
) {
    enum class Status {
        Pending,
        Archived,
        InProgress,
        ProposalSent,
        Booked,
        Todo,
        NotBooked;

        override fun toString(): String {
            return when(this) {
                Pending -> "Pending"
                Archived -> "Archived"
                InProgress -> "In progress"
                ProposalSent -> "Proposal sent"
                Booked -> "Booked"
                NotBooked -> "Not booked"
                Todo -> "To do"
            }
        }
    }

    fun getChangedFields(other: RequestModel) =
        RequestModel(
            id = id,
            createdAt = createdAt,
            startDate = if (startDate != other.startDate) other.startDate else "",
            title = if (title.orEmpty() != other.title.orEmpty()) other.title else null,
            htmlEmail = if (htmlEmail.orEmpty() != other.htmlEmail.orEmpty()) other.htmlEmail else null,
            endDate = if (endDate != other.endDate) other.endDate else "",
            guestCount = if (guestCount != other.guestCount) other.guestCount else -1,
            areas = if (areas.orEmpty() != other.areas.orEmpty()) other.areas else null,
            extras = if (extras.orEmpty() != other.extras.orEmpty()) other.extras else null,
            ownerId = if (ownerId.orEmpty() != other.ownerId.orEmpty()) other.ownerId else null,
            status = if (status != other.status) other.status else null,
            clients = if (clients.orEmpty() != other.clients.orEmpty()) other.clients else null,
            proposalId = if (proposalId.orEmpty() != other.proposalId.orEmpty()) other.proposalId else null,
            travelAgent = if (travelAgent != other.travelAgent) other.travelAgent else null,
            guestDetails = if (guestDetails.orEmpty() != other.guestDetails.orEmpty()) other.guestDetails else null,
        )

    val isEmpty get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            RequestModel(
                id = "",
                createdAt = "",
                startDate = "",
                endDate = "",
                guestCount = -1,
                areas = null,
                title = null,
                htmlEmail = null,
                proposalId = null,
                travelAgent = null,
                extras = null,
                ownerId = null,
                status = null,
                clients = null,
                guestDetails = null,
            )
    }
}
